import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Icon } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";
import type { ReactNode } from "react";

import { t } from "@/i18n-js/instance";

import { PIP_POSITION_CLASS_NAMES, PIP_SIZE_RATIO_BY_SIZE } from "../constants";
import { useVideoClipContext } from "../VideoClipContext";

interface LivePreviewProps {
  children?: ReactNode;
}

export const LivePreview = ({ children }: LivePreviewProps) => {
  const {
    cameraPreviewRef,
    isCameraEnabled,
    isScreenSharing,
    pipPosition,
    pipShape,
    pipSize,
    videoRef,
  } = useVideoClipContext();

  return (
    <div className="bg-primary relative aspect-video w-full overflow-hidden rounded-lg">
      <video
        ref={videoRef}
        autoPlay
        playsInline
        muted
        className="size-full object-cover"
      />
      {isScreenSharing && isCameraEnabled && (
        <div
          className={classNames(
            "absolute aspect-square overflow-hidden border-2 border-white/95 shadow-xl shadow-black/25",
            PIP_POSITION_CLASS_NAMES[pipPosition],
            pipShape === "round" ? "rounded-full" : "rounded-md",
          )}
          style={{
            height: `${PIP_SIZE_RATIO_BY_SIZE[pipSize] * 100}%`,
          }}
        >
          <video
            ref={cameraPreviewRef}
            autoPlay
            playsInline
            muted
            className="size-full object-cover"
          />
        </div>
      )}
      {!isCameraEnabled && !isScreenSharing && (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-black">
          <Icon name="video" size="lg" color="secondary" />
          <Typography variant="body-sm" color="secondary">
            {t("tiptap.video_clip.camera_off")}
          </Typography>
        </div>
      )}
      {children}
    </div>
  );
};
